<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <div class="page-title-box d-sm-flex align-items-center justify-content-between">
        <h4 class="mb-sm-0">SAP Categories Management</h4>
        <div class="page-title-right">
          <ol class="breadcrumb m-0">
            <li class="breadcrumb-item"><a routerLink="/dashboard">Menu</a></li>
            <li class="breadcrumb-item active">Add SAP Category</li>
          </ol>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-header align-items-center d-flex">
          <h4 class="card-title mb-0 flex-grow-1">Add SAP Category</h4>
          <div class="flex-shrink-0">
            <a routerLink="/ecomm/sap-categories" class="btn btn-light me-2">Cancel</a>
            <button type="button" class="btn btn-primary" (click)="submit()">Add SAP Category</button>
          </div>
        </div>
        <div class="card-body">
          <div class="row gy-4">
            <div class="col-xxl-6 col-md-6">
              <label class="form-label" for="sapCategoryName">Name <span class="text-danger">*</span></label>
              <input type="text" class="form-control" id="sapCategoryName" name="name" [(ngModel)]="form.name"
                     [ngClass]="{'is-invalid': !form.name && validationTriggered, 'is-valid': validationTriggered && form.name}">
            </div>
            <div class="col-xxl-6 col-md-6">
              <label class="form-label" for="sapCategoryId">SAP Category ID</label>
              <input type="text" inputmode="numeric" pattern="[0-9]*" class="form-control" id="sapCategoryId"
                     name="sap_category_id" [(ngModel)]="form.sap_category_id" placeholder="Numbers only"
                     (input)="onSapCategoryIdInput($event)">
            </div>
            <div class="col-xxl-6 col-md-6">
              <label class="form-label" for="sapCategoryStatus">Status <span class="text-danger">*</span></label>
              <select class="form-select" id="sapCategoryStatus" name="status" [(ngModel)]="form.status">
                <option [ngValue]="1">Active</option>
                <option [ngValue]="2">Inactive</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
